import React, { useState } from 'react';
import { IconButton } from '../IconButton';
import styles from './collapsibleRailSection.scss';
import { classnames } from '../../helpers/classnames';

type Props = {
  sectionTitle?: React.ReactNode;
  children?: React.ReactNode;
  isLast?: boolean;
};

export const CollapsibleRailSection: React.FC<Props> = ({ sectionTitle, children, isLast = false }) => {
  const [expanded, setExpanded] = useState(false);
  const onClickHeader = () => setExpanded(!expanded);
  const icon = expanded ? 'caret_up' : 'caret_down';
  const containerClassName = classnames(styles.collapsibleContainer, isLast && styles.lastSection);

  return (
    <div className={containerClassName}>
      <div className={expanded ? styles.expandedSectionHeader : styles.sectionHeader}>
        <>{sectionTitle}</>
        <IconButton size="md" name={icon} onClick={onClickHeader} datatestid="rightrailheader" arialabel="hi" />
      </div>
      <div>{expanded && children}</div>
    </div>
  );
};
